import type { I18nDto } from '@bldsoft/cappie/api/wbs'
import type { INoraTranslationsFormat } from '@setplex/tria-api'

export const translationsFromNoraFormat = (
  content: readonly I18nDto[]
): INoraTranslationsFormat => {
  return content.map(({ locale, translations, languageName, defaultLang }) => ({
    locale,
    languageName,
    translations,
    defaultLang,
  })) as INoraTranslationsFormat
}
